module.exports = __webpack_public_path__ + "static/Earth-8b902b5db879f4218f7959f38f86577f.png";